module.exports = __webpack_public_path__ + "img/Candy_bar.4f49723.jpg";